/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';
import { Trans, translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import { browserHistory } from 'services/ServiceRegistry';

import { ElectroButton } from 'components/ExtendedUiElements/customized.js';

import type { TypeWithEmailModel } from 'models/AccountModels';

import CentralForm from 'components/CentralForm/CentralForm.js';

import styles from 'common-scss/formstyles.module.scss';

//PasswordReset.js

function PasswordResetP({ emailModel, t }: TypeWithEmailModel & TranslatorProps): React.Element<*> {
  return browserHistory.location.state && !browserHistory.location.state.success ? (
    <CentralForm>
      <h1>{t('general:accounts.reset_password_failed')}</h1>
      <form>
        <p>{t(`${browserHistory.location.state.message}`)}</p>

        <Link to="/login" className={styles['button-anchor']}>
          <ElectroButton label={t('general:accounts.return_to_sign_in')} color="primary" />
        </Link>
      </form>
    </CentralForm>
  ) : (
    <CentralForm>
      <h1>{t('general:accounts.check_your_email')}</h1>
      <form>
        <p>
          <Trans i18nKey="general:accounts.messages.email_sent">
            <strong>{emailModel.email}</strong>
          </Trans>
          <br />
          {t('general:accounts.messages.reset_password_link')}
        </p>

        <Link to="/login" className={styles['button-anchor']}>
          <ElectroButton label={t('general:accounts.return_to_sign_in')} color="primary" />
        </Link>
      </form>
    </CentralForm>
  );
}

const PasswordReset: (props: TypeWithEmailModel) => React.Element<*> = translate()(
  inject('emailModel')(PasswordResetP)
);

export default PasswordReset;
